module.exports = __webpack_public_path__ + "img/schedule.4ea40aea.svg";